import Vue from "vue";
import App from "./App.vue";
import router from "./route/index";
import store from "./store/index";
import request from "./plugins/http/request";
import config from "./plugins/http/api";
import ElementUI from "element-ui";
import NProgress from "nprogress";
import echarts from 'echarts'
import "element-ui/lib/theme-chalk/index.css";
import "./styles/common.scss";
import "nprogress/nprogress.css";
import components from "./components";
import "./permission";
import CKEditor from '@ckeditor/ckeditor5-vue';//CKEditor编辑器
import VueQuillEditor from 'vue-quill-editor'; //VueQuillEditor编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Tinymce from 'tinymce'; //新加的tinymce富文本富文本编辑器



// Vue.use(VueQuillEditor)

Vue.use(CKEditor);
// Vue.use($);
NProgress.configure({
  showSpinner: false
});
// 全局注册组件
Vue.use(ElementUI);

components.forEach(component => Vue.use(component));

// 挂载提示方法
Vue.prototype.$toast = toast;
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = request;
Vue.prototype.$api = config.API;
Vue.prototype.$URL = config.BASE_URL;
Vue.prototype.$tinymce = Tinymce; 

Vue.config.productionTip = false;
function toast(type, message) {
  return this.$notify({
    duration: 2000,
    type,
    message
  });
}

let vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vue;
